import { NumberInput } from 'components/NumberInput';
import { useSelector } from 'react-redux';
import { getMetricType } from 'store/settings/selectors';
import { CONVERSIONS, getMetricUnit } from 'util/conversions';
import type { FlowCurvePointInterface } from './FlowCurve';
import type { FlowPropertiesProps } from '../withFlowProperties';
import { withFlowProperties } from '../withFlowProperties';

type Props = {
  field: 'pxxOne' | 'pxxTwo' | 'pxxThree';
  pxxPoints: FlowCurvePointInterface[] | undefined;
};

const PxxInputDisplay = ({
  field,
  pxxPoints,
  flowProperties,
}: Props & FlowPropertiesProps) => {
  const metricType = useSelector(getMetricType);
  const value = flowProperties[field];

  // Use tolerance-based comparison to handle floating point precision issues
  const pxxPoint = value
    ? pxxPoints?.find((p) => Math.abs(p.y - value) < 0.001)
    : undefined;
  const pxxValue = pxxPoint?.x;

  if (!pxxValue) {
    return null;
  }

  return (
    <NumberInput
      value={pxxValue}
      conversionType={CONVERSIONS.MILLIMETER}
      setValue={() => {}}
      label={`[${getMetricUnit(metricType, CONVERSIONS.MILLIMETER)}]`}
      optional
      disabled
      marginRight={16}
    />
  );
};

export default withFlowProperties(PxxInputDisplay);
